import { DependencyGroup, DependencyTaskGroup } from '@app/domain';
import { DependencyGroupDTO, DependencyTaskGroupDTO } from '../dtos';

export class TaskDependenceMapper {
  dependencyGroupToDomain(dto: DependencyGroupDTO[]): DependencyGroup[] {
    return dto.map(group => ({
      id: group.id,
      dependencyName: group.dependencyName,
      dependencies: group.dependencies,
      isEditing: group.isEditing,
    }));
  }

  dependencyTaskGroupToDomain(
    dto: DependencyTaskGroupDTO[]
  ): DependencyTaskGroup[] {
    return dto.map(group => ({
      id: group.id,
      taskGroupId: group.taskGroupId,
      dependencyName: group.dependencyName,
      dependencies: group.dependencies,
    }));
  }
}
